import React from 'react';
import { specialTexts } from '../contexts/Lang1K';

import kosmosImg1 from '../assets/images/1kosmos/1k-1.png';
import kosmosImg2 from '../assets/images/1kosmos/1k-2.png';
import kosmosImg3 from '../assets/images/1kosmos/1k-3.png';
import kosmosImg4 from '../assets/images/1kosmos/1k-4.png';
import kosmosImg5 from '../assets/images/1kosmos/1k-5.png';
import kosmosImg6 from '../assets/images/1kosmos/1k-6.png';

function Product1KSpecial({ lang = 'ko', isMobile = false }) {
  return (
    <div
      style={{
        width: '100vw',
        maxWidth: '100vw',
        background: 'transparent', // 바탕색을 투명하게 변경
        borderRadius: 12,
        boxShadow: '0 2px 12px rgba(0,0,0,0.10)',
        padding: isMobile ? '0 10px' : '0',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
      }}
    >
      <span style={{
        fontSize: isMobile ? '1.6rem' : '2rem',
        fontWeight: 700,
        color: '#fff', // 글씨 색을 흰색으로 변경
        marginBottom: isMobile ? 12 : 16,
        paddingLeft: isMobile ? 20 : 40,
        paddingRight: isMobile ? 20 : 0,
        paddingTop: isMobile ? 20 : 28,
        display: 'block',
        lineHeight: 1.3,
        textAlign: 'center', // 가운데 정렬 추가
        width: '100%'        // 부모 div 기준으로 가운데 정렬 적용
      }}>
        {specialTexts.title[lang]}
      </span>
      <div
        className="kosmos-grid"
        style={{
          display: 'grid',
          gridTemplateColumns: isMobile ? '1fr' : 'repeat(3, 1fr)',
          gap: isMobile ? '20px' : '32px',
          width: '100%',
          padding: isMobile ? '20px 20px 32px 20px' : '32px 40px 40px 40px',
          boxSizing: 'border-box'
        }}
      >
        {/* 1 */}
        <div
          style={{
            background: '#F5F6FA',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: isMobile ? '24px 20px' : '32px 24px',
            fontSize: isMobile ? '1.1rem' : '1.2rem',
            fontWeight: 600,
            color: '#29225C',
            minHeight: isMobile ? 'auto' : 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <img src={kosmosImg1} alt="1KOSMOS" style={{ 
            width: isMobile ? 80 : 96, 
            height: isMobile ? 80 : 96, 
            marginBottom: isMobile ? 10 : 12 
          }} />
          {specialTexts.platformtitle[lang]} <br />
          <span style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: 500,
            color: '#222',
            display: 'block',
            marginTop: isMobile ? 10 : 12
          }}>
            {specialTexts.platformmessage[lang]}
          </span>
        </div>
        {/* 2 */}
        <div
          style={{
            background: '#F5F6FA',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: isMobile ? '24px 20px' : '32px 24px',
            fontSize: isMobile ? '1.1rem' : '1.2rem',
            fontWeight: 600,
            color: '#29225C',
            minHeight: isMobile ? 'auto' : 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <img src={kosmosImg2} alt="1KOSMOS" style={{ 
            width: isMobile ? 80 : 96, 
            height: isMobile ? 80 : 96, 
            marginBottom: isMobile ? 10 : 12 
          }} />
          {specialTexts.usertitle[lang]} <br />
          <span style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: 500,
            color: '#222',
            display: 'block',
            marginTop: isMobile ? 10 : 12
          }}>
            {specialTexts.usermessage[lang]}
          </span>
        </div>
        {/* 3 */}
        <div
          style={{
            background: '#F5F6FA',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: isMobile ? '24px 20px' : '32px 24px',
            fontSize: isMobile ? '1.1rem' : '1.2rem',
            fontWeight: 600,
            color: '#29225C',
            minHeight: isMobile ? 'auto' : 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <img src={kosmosImg3} alt="1KOSMOS" style={{ 
            width: isMobile ? 80 : 96, 
            height: isMobile ? 80 : 96, 
            marginBottom: isMobile ? 10 : 12 
          }} />
          {specialTexts.privacytitle[lang]} <br />
          <span style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: 500,
            color: '#222',
            display: 'block',
            marginTop: isMobile ? 10 : 12
          }}>
            {specialTexts.privacymessage[lang]}
          </span>
        </div>
        {/* 4 */}
        <div
          style={{
            background: '#F5F6FA',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: isMobile ? '24px 20px' : '32px 24px',
            fontSize: isMobile ? '1.1rem' : '1.2rem',
            fontWeight: 600,
            color: '#29225C',
            minHeight: isMobile ? 'auto' : 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <img src={kosmosImg4} alt="1KOSMOS" style={{ 
            width: isMobile ? 80 : 96, 
            height: isMobile ? 80 : 96, 
            marginBottom: isMobile ? 10 : 12 
          }} />
          {specialTexts.devtitle[lang]} <br />
          <span style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: 500,
            color: '#222',
            display: 'block',
            marginTop: isMobile ? 10 : 12
          }}>
            {specialTexts.devmessage[lang]}
          </span>
        </div>
        {/* 5 */}
        <div
          style={{
            background: '#F5F6FA',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: isMobile ? '24px 20px' : '32px 24px',
            fontSize: isMobile ? '1.1rem' : '1.2rem',
            fontWeight: 600,
            color: '#29225C',
            minHeight: isMobile ? 'auto' : 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <img src={kosmosImg5} alt="1KOSMOS" style={{ 
            width: isMobile ? 80 : 96, 
            height: isMobile ? 80 : 96, 
            marginBottom: isMobile ? 10 : 12 
          }} />
          {specialTexts.liveidtitle[lang]} <br />
          <span style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: 500,
            color: '#222',
            display: 'block',
            marginTop: isMobile ? 10 : 12
          }}>
            {specialTexts.liveidmessage[lang]}
          </span>
        </div>
        {/* 6 */}
        <div
          style={{
            background: '#F5F6FA',
            borderRadius: 10,
            boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
            padding: isMobile ? '24px 20px' : '32px 24px',
            fontSize: isMobile ? '1.1rem' : '1.2rem',
            fontWeight: 600,
            color: '#29225C',
            minHeight: isMobile ? 'auto' : 160,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            textAlign: 'center'
          }}
        >
          <img src={kosmosImg6} alt="1KOSMOS" style={{ 
            width: isMobile ? 80 : 96, 
            height: isMobile ? 80 : 96, 
            marginBottom: isMobile ? 10 : 12 
          }} />
          {specialTexts.certititle[lang]} <br />
          <span style={{
            fontSize: isMobile ? '1rem' : '1.1rem',
            fontWeight: 500,
            color: '#222',
            display: 'block',
            marginTop: isMobile ? 10 : 12
          }}>
            {specialTexts.certimessage[lang]}
          </span>
        </div>
      </div>

    </div>
  );
}

export default Product1KSpecial;